import {Pipe, PipeTransform} from '@angular/core';
import {ICardColumn} from './match-columns-step.component';

@Pipe({
  name: 'isMappingFieldRequired',
  standalone: true
})
export class IsMappingFieldRequiredPipe implements PipeTransform {

  transform(card: ICardColumn | ICardColumn[] ): boolean {
   if(Array.isArray(card)  ) {
       return card.some(x=>x.is_required === true);
   }else {
       return card.is_required === true;
   }
  }

}
